module.exports = __webpack_public_path__ + "img/OT934.1465ee1.jpg";